<script setup lang="ts">
//#region imports
import { ref } from 'vue';
import type { GetDomainsManagementPlatformServersResponse } from '@/types/openapi-ts';
//#endregion

//#region types
interface Props {
  initCommands: GetDomainsManagementPlatformServersResponse['payload'][number]['init_commands'],
}

export interface PlatformServerInitScriptParams {
  data?: Props;
}
//#endregion

//#region define
const props = defineProps<Props>();
//#endregion

//#region state
const isVisible = ref(false);
//#endregion

//#region methods
function open() {
  isVisible.value = true;
}

function handleClose() {
  isVisible.value = false;
}
//#endregion

defineExpose({
  open,
});
</script>

<template>
  <Popup
    v-model:is-visible="isVisible"
    class="platform-server-init-script-popup"
    :title="$t(`domainManagement.popup.initCommands`)"
    :width="480"
    @close="handleClose"
  >
    <template v-slot:body>
      <div class="t:space-y-16">
        <UiTextarea
          v-for="(initCommand, index) in props.initCommands"
          :key="index"
          :model-value="initCommand"
          :label="$t('domainManagement.popup.step', {count: index + 1})"
          :rows="5"
          readonly
          is-copy
          resize="vertical"
          class="platform-server-init-script-popup__textarea"
        />
      </div>
    </template>
    <template v-slot:footer>
      <div class="t:justify-end t:flex">
        <UiButton
          filled
          size="big"
          icon="check"
          @click="handleClose"
        >
          {{ $t(`domainManagement.popup.done`) }}
        </UiButton>
      </div>
    </template>
  </Popup>
</template>

<style lang="scss">
.platform-server-init-script-popup {
  &__textarea{
    .el-textarea__inner{
      font-size: 13px;

      font-weight: 400;
      line-height: 120%; /* 15.6px */
      font-style: italic;
      color: var(--text-body-secondary);
    }
  }
}
</style>
